import { createSlice } from '@reduxjs/toolkit';

// The time unit of the last telemetry search ('days', 'months', …), for the
// chart's axis labels and tooltips. The heating-platform demo rows live in
// telemetry/demo/hpDemoTelemetry.js.
const initialState = {
  intervalUnit: '',
};

const telemetryChartDataSlice = createSlice({
  name: 'telemetryChartData',
  initialState,
  reducers: {
    setTelemetryIntervalUnit: (state, action) => {
      state.intervalUnit = action.payload;
    },
  },
});

export default telemetryChartDataSlice;
export const selectTelemetryChartData = (state) => state.telemetryChartData;
export const { setTelemetryIntervalUnit } = telemetryChartDataSlice.actions;
